import React from 'react';
// import axios from 'axios';
import PropTypes from 'prop-types';
import Slider from 'react-slick';
import { gaWrapper } from 'helpers/analytics';
import { inViewForReact } from 'utils/common';
// import throttle from 'lodash.throttle';
import Link from 'components/Link';
import InterSectionBorder from 'components_v2/common/InterSectionBorder';
import CardV4 from 'components_v2/common/CardV4';
import CardV5 from 'components_v2/common/CardV5';
import FlipAnimator from 'components_v2/common/FlipAnimator';
// import ImageV2 from 'components_v2/common/ImageV2';
import AdCaller from 'helpers/ads/adCaller';
import { LayoutType } from 'components/MiniTvV3/util';
//import { sendGaThroughProps } from 'helpers/analytics/sendGaThroughProps';
import LiveblogInsert from '../../../components/mobile/LiveblogInsert';
import MinitvContainer from '../../../../../components/MiniTvV3/MinitvContainer';
import MinitvWrapper from './../../../../../components/MiniTvV3/MinitvWrapper';
import LiveblogUpdates from '../../../../../components/ElectionV2/common/LiveblogUpdates/LiveblogUpdates';
import BudgetLinkout from './BudgetLinkout';
import s from './BudgetNewHPWidget.scss';
// import { IMAGE_URL } from '../../../../../constants';
import analyticsWrapper from '../../../../../helpers/analytics/analyticsWrapper';
import ErrorBoundary from '../../../../../components/ErrorBoundary/ErrorBoundary';

// const defaultSkew = 500;
class BudgetNewHPWidget extends React.Component {
  constructor() {
    super();
    this.ref = React.createRef();
    this.sliderRef = React.createRef();
    this.gaFired = false;
    this.ga4Type = 'budget_hp_widget';
    this.state = {
      isWrapperEnabled: false,
    };
  }

  componentDidMount() {
    // this.throttledInView = throttle(this.checkDomIsInView.bind(this), 10);
    this.sendGAEvent();

    if (window?._dfpObj?.adsCallEvent) {
      window._dfpObj.adsCallEvent('rajFrontAd', () => {
        this.setState({ isWrapperEnabled: true });
      });
    }
    // window.addEventListener('scroll', this.throttledInView);
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.throttledInView);
    if (this.timer) {
      clearInterval(this.timer);
    }
  }

  checkDomIsInView() {
    if (
      this.ref &&
      this.ref.current &&
      inViewForReact(this.ref.current, 0, true)
    ) {
      this.sendGAEvent();
    }
  }

  sendGAEvent = () => {
    if (!this.gaFired) {
      analyticsWrapper('ga4', {
        event: 'user_shown',
        type: this.ga4Type,
      });
      this.gaFired = true;
    }
  };

  renderBudgetDownload(link, heading) {
    return (
      <button
        className={`${s.buttonlinks}`}
        onClick={() => this.startBudgetDownload(link)}
      >
        {heading}
      </button>
    );
  }

  renderBudgetAds = (fliper, name = '') => (
    <FlipAnimator>
      <div className={s.imageText}>
        {/* <ImageV2 src={`${IMAGE_URL}msid-${fliper.frontImage}.cms`} /> */}
        <AdCaller data={{ jname: `rajFrontAd${name}`, skipLazy: 1 }} />
        {fliper?.frontTitle && <span>{fliper.frontTitle}</span>}
      </div>
      <div className={s.imageText}>
        {/* <ImageV2 src={`${IMAGE_URL}msid-${fliper.backImage}.cms`} /> */}
        <AdCaller data={{ jname: `rajBackAd${name}`, skipLazy: 1 }} />
        {fliper?.backTitle && <span>{fliper.backTitle}</span>}
      </div>
    </FlipAnimator>
  );

  startBudgetDownload = link => {
    window.open(link);
    gaWrapper(
      'send',
      'event',
      'Budget Widget',
      `Download`,
      `Budget Full Speech`,
    );
  };

  sliceIntoChunks = (arr, chunkSize) => {
    const res = [];
    for (let i = 0; i < arr.length; i += chunkSize) {
      const chunk = arr.slice(i, i + chunkSize);
      res.push(chunk);
    }
    return res;
  };

  handleSliderAfterChange = (currentSlide, slidesToShow, totalSlides) => {
    // Calculate the last possible slide index
    const lastSlideIndex = totalSlides - slidesToShow;

    // If we've reached the end, reset to the first slide
    if (currentSlide >= lastSlideIndex && this.sliderRef.current) {
      setTimeout(() => {
        if (this.sliderRef.current && this.sliderRef.current.slickGoTo) {
          this.sliderRef.current.slickGoTo(0, false);
        }
      }, 5000);
    }
  };

  renderLiveblogList = lbgList =>
    Array.isArray(lbgList) && lbgList.length ? (
      lbgList.map(item => (
        <CardV5
          data={item}
          datanewga="BudgetWidget-Actions"
          ga4Type={this.ga4Type}
        />
      ))
    ) : (
      <CardV5
        data={lbgList}
        datanewga="BudgetWidget-Actions"
        ga4Type={this.ga4Type}
      />
    );

  renderCrest(fliper, wrapper, name = '') {
    const isFlipActive =
      fliper?.tn === 'crest' &&
      (!this.props.isPrime ||
        (fliper?.primeDisabled && fliper?.primeDisabled !== '1'));
    if (!isFlipActive) {
      return null;
    }
    const classes = `${wrapper}`;
    return (
      <div className={this.state.isWrapperEnabled ? classes : ''}>
        {fliper?.link ? (
          <Link to={fliper?.link}>
            {this.renderBudgetAds(fliper, `${name}withminitv`)}
          </Link>
        ) : (
          this.renderBudgetAds(fliper, `${name}withminitv`)
        )}
      </div>
    );
  }

  render() {
    const { data, isWapView } = this.props;
    const isPrime = true;
    const cardcount = !isPrime ? 1 : 2;

    if (
      typeof data !== 'undefined' &&
      !data.budgetdata &&
      !data.budgetdata.budgetlbglead &&
      !data.budgetdata.budgetlbglead.item
    ) {
      return null;
    }
    const leadData = data.budgetdata.budgetlbglead.item;
    const minitvLayout = !!(
      data?.budgetdata?.withminitv && data.budgetdata.withminitv === '1'
    );
    const { dataUrl } = data?.budgetdata?.budgetlbglead;
    const liveblogData = data?.budgetdata?.liveblog;
    if (isWapView) leadData.dataUrl = dataUrl;
    if (isWapView) leadData.type = 'lbgfeatured';
    leadData.tn = 'news';
    let lbgList =
      data?.budgetdata?.budgetlbglist &&
      data.budgetdata.budgetlbglist.items &&
      Array.isArray(data.budgetdata.budgetlbglist.items) &&
      data.budgetdata.budgetlbglist.items.length
        ? data.budgetdata.budgetlbglist.items
        : undefined;

    const lbgListType =
      data.budgetdata.budgetlbglist &&
      data.budgetdata.budgetlbglist &&
      data.budgetdata.budgetlbglist.type;
    if (
      !isWapView &&
      lbgListType === 'two_card_list' &&
      lbgList &&
      lbgList.length &&
      !minitvLayout
    ) {
      lbgList = this.sliceIntoChunks(lbgList, 2);
    }

    const slidesToShow = minitvLayout ? 4 : cardcount;
    const slidesToScroll = minitvLayout ? 1 : 1;

    // Calculate total slides for reset logic
    const totalSlides = lbgList && Array.isArray(lbgList) ? lbgList.length : 0;

    const settings = {
      slidesToShow,
      slidesToScroll,
      pauseOnHover: false,
      pauseOnFocus: false,
      dots: true,
      arrows: true,
      swipeToSlide: true,
      autoplay: true,
      autoplaySpeed: 4500,
      draggable: false,
      infinite: false,
      afterChange: currentSlide => {
        this.handleSliderAfterChange(currentSlide, slidesToShow, totalSlides);
      },
    };

    if (typeof leadData === 'undefined' || (leadData && leadData.length < 1)) {
      return null;
    }
    const { linkout, fliper } = data.budgetdata;
    // const shareImage = `https://static.toiimg.com/photo/${
    //   leadData.imageid ? leadData.imageid : '47529300'
    // }.cms`;

    const datanewga = 'BudgetWidget-Actions';
    let mwebBudgetLinkWrapper = 'linkouts ';
    if (this.state.isWrapperEnabled) {
      mwebBudgetLinkWrapper += s.mflipWraaper;
    }

    return (
      <>
        {isWapView ? (
          <div className={s.widgetContainer} ref={this.ref}>
            {/* <div className={s.head}>
              <div className={s.topRow}>
                <Link
                  to={leadData.wu}
                  target="_blank"
                  data-newga={`${datanewga}#${leadData.wu}`}
                  ga4Data={[
                    {
                      event: 'user_click',
                      type: this.ga4Type,
                      category: 'story_click',
                      msid: data?.id,
                    },
                  ]}
                >
                  <div className={s.liveBtn}>BUDGET LIVE</div>
                </Link>
                {leadData.logioimageid && (
                  <>
                    <span>/</span>
                    <Link
                      to={leadData.logoUrl ? leadData.logoUrl : leadData.wu}
                      target="_blank"
                      data-newga={`${datanewga}#${
                        leadData.logoUrl ? leadData.logoUrl : leadData.wu
                      }`}
                      ga4Data={[
                        {
                          event: 'user_click',
                          type: this.ga4Type,
                          label: leadData?.logoUrl || leadData?.wu,
                        },
                      ]}
                    >
                      <img
                        src={`https://static.toiimg.com/photo/${
                          leadData.logioimageid
                        }.cms`}
                        alt=""
                      />
                    </Link>
                  </>
                )}
              </div>
            </div> */}
            <div
              className={`${s.blogWrap} ${
                minitvLayout ? s.minitvLayoutBlogWrap : ''
              }`}
            >
              {leadData &&
                (isWapView && !minitvLayout) && (
                  <LiveblogInsert
                    sectionData={leadData}
                    isWapView={isWapView}
                    datanewga={datanewga}
                    isBudget
                    ga4Type={this.ga4Type}
                  />
                )}
              {minitvLayout &&
                isWapView &&
                liveblogData && (
                  <div className={`${s.liveBlogCapsuleWrap}`}>
                    <ErrorBoundary>
                      <LiveblogUpdates
                        isWapView={isWapView}
                        liveblogData={liveblogData}
                        storiesCount={1}
                        liveBlogCapsule
                        ga4Data={[
                          {
                            event: 'user_click',
                            type: 'budget_hp_widget',
                            label: 'view_more_update',
                          },
                        ]}
                      />
                    </ErrorBoundary>
                  </div>
                )}
              {!isWapView && this.renderCrest(fliper, s.flipWrap)}

              {minitvLayout && (
                <div className={s.miniTvMobile}>
                  <MinitvContainer
                    isWapView
                    containerClass="wMwebInpagePip withbudget"
                    dockGlobalClass="budgetminitvdocker"
                  />
                </div>
              )}
              <div className={s.otherBlogWrap}>
                {/* <h4>Other Live Blogs</h4> */}
                {Array.isArray(lbgList) &&
                  lbgList.length && (
                    <div className={s.mSlider}>
                      {lbgList.map(lblist => (
                        <div className={s.cardBox}>
                          {this.renderLiveblogList(lblist)}
                        </div>
                      ))}
                    </div>
                  )}
              </div>
              <div className={mwebBudgetLinkWrapper}>
                {isWapView && this.renderCrest(fliper, s.flipWrap, 'mweb')}
                {linkout?.tn === 'linkoutslider' && (
                  <BudgetLinkout
                    data={linkout}
                    isWapView={isWapView}
                    cardcount={3.1}
                    datanewga={datanewga}
                    ga4Type={this.ga4Type}
                    minitvLayout={minitvLayout}
                  />
                )}
              </div>
            </div>
          </div>
        ) : (
          <div
            ref={this.ref}
            className={`
            ${this.props.wrapperclass ? s[this.props.wrapperclass] : ''}
          ${s.supperWrap} ${minitvLayout ? s.minitvLayout : ''}`}
          >
            <section
              className={`
                ${s.budgetWrap}
                ${!isPrime ? s.budgetWrapNoPrime : ''}
                ${minitvLayout ? s.minitvLayoutWrap : ''}
              `}
            >
              {!minitvLayout ? (
                <article>
                  <CardV4
                    data={leadData}
                    datanewga={datanewga}
                    ga4Type={this.ga4Type}
                  />
                </article>
              ) : (
                <div className={s.dataWrapper}>
                  <div className={s.miniTv}>
                    <MinitvWrapper layoutType={LayoutType[3]} />
                  </div>
                  <div className={`${s.liveBlogCapsuleWrap}`}>
                    <ErrorBoundary>
                      <LiveblogUpdates
                        isWapView={false}
                        liveblogData={liveblogData}
                        storiesCount={liveblogData?.storyCount || 2}
                        ga4Data={[
                          {
                            event: 'user_click',
                            type: 'budget_hp_widget',
                            label: 'view_more_update',
                          },
                        ]}
                      />
                    </ErrorBoundary>
                  </div>
                  <div
                    className={`${s.linkouts} ${s.flipTop} ${
                      fliper?.tn === 'crest' &&
                      this.state.isWrapperEnabled &&
                      (!this.props.isPrime ||
                        (fliper?.primeDisabled &&
                          fliper?.primeDisabled !== '1'))
                        ? `${s.flipVisible} flipVisible`
                        : ''
                    }`}
                  >
                    {fliper?.tn === 'crest' &&
                      (!this.props.isPrime ||
                        (fliper?.primeDisabled &&
                          fliper?.primeDisabled !== '1')) && (
                        <div
                          className={`${
                            this.state.isWrapperEnabled ? s.flipWrap : ''
                          }`}
                        >
                          {fliper?.link ? (
                            <Link to={fliper?.link}>
                              {this.renderBudgetAds(fliper, 'withminitv')}
                            </Link>
                          ) : (
                            this.renderBudgetAds(fliper, 'withminitv')
                          )}
                        </div>
                      )}
                    {linkout?.tn === 'linkoutslider' && (
                      <BudgetLinkout
                        data={linkout}
                        isWapView
                        cardcount={6}
                        datanewga={datanewga}
                        wrapperclass={s.linkoutWrapper}
                        ga4Type={this.ga4Type}
                        minitvLayout={minitvLayout}
                      />
                    )}
                  </div>
                </div>
              )}

              {minitvLayout
                ? Array.isArray(lbgList) &&
                  lbgList.length && (
                    <div className={`${s.rightWrap} slick_UI`}>
                      <Slider ref={this.sliderRef} {...settings}>
                        {lbgList.map(lblist => (
                          <div className={s.cardBox}>
                            {this.renderLiveblogList(lblist)}
                          </div>
                        ))}
                      </Slider>
                    </div>
                  )
                : Array.isArray(lbgList) &&
                  lbgList.length > 0 && (
                    <div className={`${s.rightWrap} slick_UI`}>
                      {!isPrime ? (
                        lbgList.map(lblist => (
                          <div
                            className={s.cardBox}
                            key={JSON.stringify(lblist)}
                          >
                            {this.renderLiveblogList(lblist)}
                          </div>
                        ))
                      ) : (
                        <Slider ref={this.sliderRef} {...settings}>
                          {lbgList.map(lblist => (
                            <div
                              className={s.cardBox}
                              key={JSON.stringify(lblist)}
                            >
                              {this.renderLiveblogList(lblist)}
                            </div>
                          ))}
                        </Slider>
                      )}
                    </div>
                  )}
            </section>
            {!minitvLayout && (
              <div
                className={`${s.linkouts} ${
                  fliper?.tn === 'crest' &&
                  this.state.isWrapperEnabled &&
                  (!this.props.isPrime ||
                    (fliper?.primeDisabled && fliper?.primeDisabled !== '1'))
                    ? s.flipVisible
                    : ''
                }`}
              >
                {fliper?.tn === 'crest' &&
                  (!this.props.isPrime ||
                    (fliper?.primeDisabled &&
                      fliper?.primeDisabled !== '1')) && (
                    <div
                      className={this.state.isWrapperEnabled ? s.flipWrap : ''}
                    >
                      {fliper?.link ? (
                        <Link to={fliper?.link}>
                          {this.renderBudgetAds(fliper)}
                        </Link>
                      ) : (
                        this.renderBudgetAds(fliper)
                      )}
                    </div>
                  )}
                {linkout?.tn === 'linkoutslider' && (
                  <BudgetLinkout
                    data={linkout}
                    isWapView
                    cardcount={6}
                    datanewga={datanewga}
                    ga4Type={this.ga4Type}
                  />
                )}
              </div>
            )}
            <InterSectionBorder />
          </div>
        )}
      </>
    );
  }
}

BudgetNewHPWidget.propTypes = {
  isWapView: PropTypes.bool,
  isPrime: PropTypes.bool,
  data: PropTypes.shape({
    items: PropTypes.shape({}),
    data: PropTypes.shape({}),
    refreshUrl: PropTypes.string,
    path: PropTypes.string,
  }),
  wrapperclass: PropTypes.string,
  // skew: PropTypes.string,
};
BudgetNewHPWidget.defaultProps = {
  isWapView: false,
  isPrime: false,
  data: {},
  wrapperclass: '',
  // skew: undefined,
};

export default BudgetNewHPWidget;
